import { useEffect, useState } from 'react'
import { useGlobalContext } from '../common/hooks/useGlobalContext'
import { identifyUser } from '../common/utils/metrics'

/**
 * This component is used to identify the user in Jitsu.
 */
export function SegmentUser() {
  const { user } = useGlobalContext()
  const [initialized, setInitialized] = useState(false)

  // Identify user on first load
  useEffect(() => {
    if (!user) {
      return
    }

    if (!initialized) {
      setInitialized(true)
      identifyUser(user.id, {
        email: user.email,
        phone: user.phoneNumber,
        name: `${user.firstName} ${user.lastName}`,
        organizationName: user.organizationName,
      })
    }
  }, [user, initialized])

  return <></>
}
